import type { FlipkartAdsReportRow } from '@/api/client';

export type FlipkartReportTotals = {
  rowCount: number;
  spend: number;
  clicks: number;
  impressions: number;
  revenue: number;
  orders: number;
  dateStart: string | null;
  dateEnd: string | null;
};

export function summarizeFlipkartReportRows(rows: FlipkartAdsReportRow[]): FlipkartReportTotals {
  let spend = 0;
  let clicks = 0;
  let impressions = 0;
  let revenue = 0;
  let orders = 0;
  let dateStart: string | null = null;
  let dateEnd: string | null = null;

  for (const row of rows) {
    spend += row.spend || 0;
    clicks += row.clicks || 0;
    impressions += row.impressions || 0;
    revenue += row.revenue || 0;
    orders += row.orders || 0;
    const date = row.date?.trim() || null;
    if (!date) continue;
    if (dateStart == null || date < dateStart) dateStart = date;
    if (dateEnd == null || date > dateEnd) dateEnd = date;
  }

  return {
    rowCount: rows.length,
    spend,
    clicks,
    impressions,
    revenue,
    orders,
    dateStart,
    dateEnd,
  };
}

export function flipkartReportRoas(totals: FlipkartReportTotals): number | null {
  if (totals.spend <= 0) return null;
  return totals.revenue / totals.spend;
}

export function formatFlipkartMoney(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return value.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

export function formatFlipkartCount(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return Math.round(value).toLocaleString();
}

export function formatFlipkartRoas(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return `${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}x`;
}

export function formatFlipkartReportRange(totals: FlipkartReportTotals): string | null {
  if (!totals.dateStart) return null;
  if (!totals.dateEnd || totals.dateEnd === totals.dateStart) return totals.dateStart;
  return `${totals.dateStart} to ${totals.dateEnd}`;
}
